import '~/components/spinner.scss'

import { Trans } from '@lingui/react/macro'

export default function Spinner() {
  return (
    <div className='position-absolute top-50 start-50 translate-middle'>
      <div className='spinner-border' role='status'>
        <span className='visually-hidden'>
          <Trans>Loading...</Trans>
        </span>
      </div>
    </div>
  )
}
